import * as React from "react";
import ImageStretch from "../LogoRemovedBackground.png";
import Typography from "@mui/material/Typography";
import Smoke from "../smokeGrey.webp";
import Box from "@mui/material/Box";
import Images from "./images";
import Services from "./services";
import Contact from "./contact";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Header from "./small-screen-nav";
import Carousel from "../components/carousel";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Rating from "@mui/material/Rating";

const styles = {
  backGround: {
    backgroundColor: "black",
  },
  fitnessLogo: {
    color: "white",
  },
  headerLogoWrapper: {
    display: "flex",
  },
  image: {
    position: "absolute",
    zIndex: "-8",
    height: "479px",
    width: "100%",
  },
  video: {
    marginTop: "5%",
    width: "25%",

    border: "4px solid sandybrown",
    // borderRadius: "158px",
    boxSizing: "border-box",
    boxShadow: "1px 1px 71px whitesmoke",
    marginBottom: "4%",
  },
};

const reviewStyle = {
  background: "black",
  color: "purple",
  width: "50%",
  margin: "0px auto",
  borderRadius: "15px",
  boxShadow: "1px 1px 30px whitesmoke",
};

const reviewCardStyle = {
  background: "black",
  color: "purple",
  margin: "0px auto",
  borderRadius: "15px",
  boxShadow: "1px 1px 30px whitesmoke",
  padding: "20px",
};

const reviews = [
  {
    name: "Miranda",
    description: `"When I first started working out at Garage Gym, I was out of shape and had my energy was pretty low. My trainer, Regan, was very
     attentive to my needs and concerns and developed meal plans and workouts specifically for me. I have been working out at Garage Gym for over a year now and am in the best shape of my life!
     I have more energy, stamina and am very strong, which has positively impacted my life, especially as a busy mom of 4. I highly recommend Garage Gym!"`,
    rating: 5,
  },
  {
    name: "Jennifer",
    description: `"I have been training with Regan for several months now and I appreciate how knowledgeable he is, and as a result how he is able to customize workouts to accommodate my injuries."`,
    rating: 5,
  },
  {
    name: "Miriah",
    description: `"Regan is very attentive to my personal goals and individual needs during my health journey. Everything is personalized and I feel stronger. 10/10 recommend "`,
    rating: 5,
  },
  {
    name: "Joel",
    description: `"Regan is patient, supportive, and very attentive to our goals. The workouts were tailored to our needs and definitely saw progress."`,
    rating: 5,
  },
];

function ReviewCard({ review }) {
  return (
    <Card sx={reviewCardStyle}>
      <CardContent>
        <Typography variant="h5" component="div">
          {review.name}
        </Typography>
        <Rating name="read-only" value={review.rating} readOnly />
        <Typography variant="body2" color="text.secondary">
          {review.description}
        </Typography>
      </CardContent>
    </Card>
  );
}

function WelcomePage() {
  const theme = useTheme();
  const wideWindow = useMediaQuery(theme.breakpoints.up("md"));

  const windowChange = React.useMemo(() => {
    if (wideWindow) {
      return (
        <>
          <img alt="smoke" style={styles.image} src={Smoke}></img>
          <div style={{ margin: "0px auto" }}>
            F
            <img
              alt="stretch"
              width="200"
              height="200"
              src={ImageStretch}
            ></img>{" "}
            T N E S S{" "}
            <span style={{ marginRight: "4%", marginLeft: "4%" }}>I S</span>{" "}
            <span>L I F E</span>
          </div>
        </>
      );
    } else {
      return (
        <div style={{ backgroundColor: "black", width: "100%" }}>
          <div style={{ margin: "0px auto", width: "50%" }}>
            <img
              alt="stretch"
              width="200"
              height="200"
              src={ImageStretch}
            ></img>{" "}
          </div>
        </div>
      );
    }
  }, [wideWindow]);

  return (
    <>
      <Header></Header>
      <div style={{ backgroundColor: "black", textAlign: "center" }}>
        {" "}
        {/* Set background to black and center content */}
        <Box style={{ ...styles.headerLogoWrapper, backgroundColor: "black" }}>
          {" "}
          {/* Ensure Box background is black */}
          <Typography variant="h1" color="white" noWrap sx={{ flexGrow: 1 }}>
            <div
              style={{ ...styles.headerLogoWrapper, backgroundColor: "black" }}
            >
              {windowChange}
            </div>
          </Typography>
        </Box>
        <Images></Images>
        <Carousel items={reviews} style={reviewStyle}>
          {reviews.map((review, i) => (
            <ReviewCard key={i} review={review} />
          ))}
        </Carousel>
        <Services></Services>
        <Contact></Contact>
      </div>
    </>
  );
}

export default WelcomePage;
